import React from "react";
import PathConstants from "./pathConstants";

// Setup Flow

const UploadInsuranceCard = React.lazy(
  () => import("../pages/Product/SetupFlow/UploadInsuranceCard"),
);
const UploadProcessing = React.lazy(
  () => import("../pages/Product/SetupFlow/UploadProcessing"),
);
const ConfirmInsuranceDetails = React.lazy(
  () => import("../pages/Product/SetupFlow/ConfirmInsuranceDetails"),
);
const PrimaryEnrollee = React.lazy(
  () => import("../pages/Product/SetupFlow/PrimaryEnrollee"),
);
const DenyingPartyPage = React.lazy(
  () => import("../pages/Product/SetupFlow/DenyingPartyPage"),
);
const OtherAppealSituationsPage = React.lazy(
  () => import("../pages/Product/SetupFlow/OtherAppealSituationsPage"),
);

// Experience Flow

const AppealSurvey = React.lazy(
  () => import("../pages/Product/ExperienceFlow/AppealSurvey"),
);
const SurveyJs = React.lazy(
  () => import("../pages/Product/ExperienceFlow/SurveyJs"),
);
const ExperienceOverview = React.lazy(
  () => import("../pages/Product/ExperienceFlow/ExperienceOverview"),
);
const ExperienceSummary = React.lazy(
  () => import("../pages/Product/ExperienceFlow/ExperienceSummary"),
);

// Letter Creation Flow

const LetterBuildingInterstitial = React.lazy(
  () =>
    import("../pages/Product/LetterCreationFlow/LetterBuildingInterstitial"),
);
const AppealOverview = React.lazy(
  () => import("../pages/Product/LetterCreationFlow/AppealOverview"),
);
const PreviewComplete = React.lazy(
  () => import("../pages/Product/LetterCreationFlow/PreviewComplete"),
);
const PreviewAndReviewAppealLetter = React.lazy(
  () =>
    import("../pages/Product/LetterCreationFlow/PreviewAndReviewAppealLetter"),
);
const UploadAdditionalDocumentsPage = React.lazy(
  () => import("../pages/Product/LetterCreationFlow/UploadAdditionalDocuments"),
);
const GatherPatientData = React.lazy(
  () => import("../pages/Product/LetterCreationFlow/PatientData/PatientData"),
);
const AppealDepartment = React.lazy(
  () =>
    import(
      "../pages/Product/LetterCreationFlow/AppealDepartment/AppealDepartment"
    ),
);
const EmployerAddress = React.lazy(
  () => import("../pages/Product/LetterCreationFlow/EmployerAddress"),
);
const CcDestinations = React.lazy(
  () =>
    import("../pages/Product/LetterCreationFlow/CcDestinations/CcDestinations"),
);

// Payment Flow

const PrePayment = React.lazy(
  () => import("../pages/Product/PaymentFlow/PrePayment/PrePayment"),
);
const PaymentComplete = React.lazy(
  () => import("../pages/Product/PaymentFlow/PaymentComplete/PaymentComplete"),
);

const NotFound = React.lazy(() => import("../pages/Product/Error/NotFound"));

const routes = [
  { path: PathConstants.UploadInsuranceCard, element: <UploadInsuranceCard /> },
  {
    path: PathConstants.UploadProcessing,
    element: <UploadProcessing />,
    className: "body_background_almost_black",
  },
  {
    path: PathConstants.ConfirmInsuranceDetails,
    element: <ConfirmInsuranceDetails />,
    className: "background_white",
  },
  {
    path: PathConstants.PrimaryEnrollee,
    element: <PrimaryEnrollee />,
    className: "background_white",
  },
  {
    path: PathConstants.DenyingPartyPage,
    element: <DenyingPartyPage />,
    className: "background_white",
  },
  {
    path: PathConstants.OtherAppealSituationsPage,
    element: <OtherAppealSituationsPage />,
    className: "background_white",
  },
  {
    path: PathConstants.ExperienceOverview,
    element: <ExperienceOverview />,
    className: "body_background_light-volt-fade-down",
  },
  { path: PathConstants.AppealSurvey, element: <AppealSurvey /> },
  { path: PathConstants.SurveyJs, element: <SurveyJs /> },
  {
    path: PathConstants.ExperienceSummary,
    element: <ExperienceSummary />,
    className: "body_background_light-volt-fade-down",
  },
  {
    path: PathConstants.LetterBuildingInterstitial,
    element: <LetterBuildingInterstitial />,
    className: "body_background_almost_black",
  },
  { path: PathConstants.AppealOverview, element: <AppealOverview /> },
  {
    path: PathConstants.PreviewComplete,
    element: <PreviewComplete />,
    className: "body_background_light-volt-fade-down",
  },
  {
    path: PathConstants.PreviewAndReviewAppealLetter,
    element: <PreviewAndReviewAppealLetter />,
  },
  {
    path: PathConstants.UploadAdditionalDocuments,
    element: <UploadAdditionalDocumentsPage />,
  },
  { path: PathConstants.PatientData, element: <GatherPatientData /> },
  {
    path: PathConstants.AppealDepartment,
    element: <AppealDepartment />,
  },
  {
    path: PathConstants.EmployerAddress,
    element: <EmployerAddress />,
  },
  { path: PathConstants.CcDestinations, element: <CcDestinations /> },
  { path: PathConstants.PrePayment, element: <PrePayment /> },
  { path: PathConstants.PaymentComplete, element: <PaymentComplete /> },
  { path: PathConstants.NotFound, element: <NotFound /> },
];

export default routes;
